(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getBars(root) {
      var bars = [];
      if (root && root.matches && root.matches('[data-ann-bar]')) bars.push(root);
      if (root && root.querySelectorAll) {
        bars = bars.concat(Array.prototype.slice.call(root.querySelectorAll('[data-ann-bar]')));
      }
      return bars;
    }

    function initBars(root) {
      getBars(root).forEach(function (bar) {
        if (bar.dataset.announcementInitialized === 'true') return;
        bar.dataset.announcementInitialized = 'true';

        var key = 'citera:ann:' + bar.getAttribute('data-ann-key');
        var designMode = Boolean(window.Shopify && window.Shopify.designMode);
        if (!designMode) {
          try {
            if (localStorage.getItem(key) === '1') {
              bar.hidden = true;
              return;
            }
          } catch (e) {}
        }

        var close = bar.querySelector('[data-ann-close]');
        if (close) {
          close.addEventListener('click', function () {
            bar.hidden = true;
            if (!designMode) {
              try {
                localStorage.setItem(key, '1');
              } catch (e) {}
            }
          });
        }
      });
    }

    initBars(document);
    document.addEventListener('shopify:section:load', function (event) {
      initBars(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var progressStates = new WeakMap();

    function getArticles(root) {
      var articles = [];
      if (root && root.matches && root.matches('[data-article]')) articles.push(root);
      if (root && root.querySelectorAll) {
        articles = articles.concat(
          Array.prototype.slice.call(root.querySelectorAll('[data-article]')),
        );
      }
      return articles;
    }

    function initArticle(article) {
      if (progressStates.has(article)) return;
      var bar = article.querySelector('[data-reading-progress]');
      var content = article.querySelector('.article__content');
      if (!bar || !content) return;

      var state = { frame: 0, top: 0, total: 0 };
      var render = function () {
        state.frame = 0;
        var scrolled = Math.min(Math.max(window.scrollY - state.top, 0), Math.max(state.total, 1));
        var pct = state.total > 0 ? (scrolled / state.total) * 100 : 0;
        bar.style.width = pct + '%';
      };
      var schedule = function () {
        if (!state.frame) state.frame = window.requestAnimationFrame(render);
      };
      var measure = function () {
        var rect = content.getBoundingClientRect();
        state.top = rect.top + window.scrollY;
        state.total = Math.max(content.offsetHeight - window.innerHeight, 0);
        schedule();
      };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', measure);
      measure();
      state.schedule = schedule;
      state.measure = measure;
      progressStates.set(article, state);
    }

    function destroyArticle(article) {
      var state = progressStates.get(article);
      if (!state) return;
      window.removeEventListener('scroll', state.schedule);
      window.removeEventListener('resize', state.measure);
      if (state.frame) window.cancelAnimationFrame(state.frame);
      progressStates.delete(article);
    }

    function initArticles(root) {
      getArticles(root).forEach(initArticle);
    }

    initArticles(document);

    document.addEventListener('shopify:section:load', function (event) {
      initArticles(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      getArticles(event.target).forEach(destroyArticle);
    });

    // Copy-link share button
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy-link]');
      if (!btn) return;
      var url = btn.getAttribute('data-url');
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () {
          btn.classList.remove('is-copied');
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(url)
          .then(done)
          .catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const productRoots = (scope) => {
      const roots = Array.from(scope.querySelectorAll('[data-product]'));
      if (scope.matches?.('[data-product]')) roots.unshift(scope);
      return roots;
    };
    const init = (scope = document) => {
      productRoots(scope).forEach((root) => {
        const openBtn = root.querySelector('[data-zoom-open]');
        const dialog = root.querySelector('[data-lightbox]');
        if (
          !openBtn ||
          !dialog ||
          dialog.hasAttribute('data-lightbox-initialized') ||
          typeof dialog.showModal !== 'function'
        )
          return;
        dialog.setAttribute('data-lightbox-initialized', 'true');
        const lbImg = dialog.querySelector('[data-lightbox-img]');
        const main = root.querySelector('[data-media-main]');
        const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
        const urls = thumbs.length
          ? thumbs.map((thumb) => thumb.dataset.full)
          : [main ? main.currentSrc || main.src : ''];
        const srcsets = thumbs.length
          ? thumbs.map((thumb) => thumb.dataset.srcset || '')
          : [main ? main.srcset || '' : ''];
        const alts = thumbs.length
          ? thumbs.map((thumb) => thumb.dataset.alt || '')
          : [main ? main.alt || '' : ''];
        let index = 0;
        const show = (nextIndex) => {
          index = (nextIndex + urls.length) % urls.length;
          lbImg.src = urls[index];
          lbImg.srcset = srcsets[index] || '';
          lbImg.sizes = '100vw';
          lbImg.alt = alts[index] || lbImg.alt;
        };
        const activeIndex = () => {
          const active = thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true');
          return active >= 0 ? active : 0;
        };
        openBtn.addEventListener('click', () => {
          show(activeIndex());
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
          dialog.querySelector('[data-lightbox-close]')?.focus();
        });
        dialog
          .querySelector('[data-lightbox-close]')
          ?.addEventListener('click', () => dialog.close());
        dialog
          .querySelector('[data-lightbox-prev]')
          ?.addEventListener('click', () => show(index - 1));
        dialog
          .querySelector('[data-lightbox-next]')
          ?.addEventListener('click', () => show(index + 1));
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') show(index - 1);
          if (event.key === 'ArrowRight') show(index + 1);
        });
        dialog.addEventListener('close', () => openBtn.focus());
      });
    };
    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('citera:section:rerender', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootsIn = (scope) => {
      const roots = Array.from(scope.querySelectorAll('[data-slideshow]'));
      if (scope.matches?.('[data-slideshow]')) roots.unshift(scope);
      return roots;
    };

    const init = (scope = document) => {
      rootsIn(scope).forEach((root) => {
        if (root.hasAttribute('data-slideshow-initialized')) return;
        const track = root.querySelector('[data-slideshow-track]');
        const slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
        const dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
        if (!track || slides.length < 2) return;
        root.setAttribute('data-slideshow-initialized', 'true');

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let current = 0;
        let timer = null;
        let paused = false;

        const setCurrent = (index) => {
          current = index;
          dots.forEach((dot, i) =>
            dot.setAttribute('aria-current', i === current ? 'true' : 'false'),
          );
          slides.forEach((slide, i) => {
            if (i === current) {
              slide.removeAttribute('inert');
              slide.removeAttribute('aria-hidden');
            } else {
              slide.setAttribute('inert', '');
              slide.setAttribute('aria-hidden', 'true');
            }
          });
        };
        const go = (index, smooth = true) => {
          const next = (index + slides.length) % slides.length;
          setCurrent(next);
          track.scrollTo({
            left: slides[next].offsetLeft,
            behavior: smooth && !reduce ? 'smooth' : 'auto',
          });
        };
        const speed = Math.max(2, parseInt(root.dataset.autoplaySpeed, 10) || 6) * 1000;
        const stop = () => {
          clearInterval(timer);
          timer = null;
        };
        const start = () => {
          if (!paused && !timer && root.dataset.autoplay === 'true' && !reduce) {
            timer = setInterval(() => go(current + 1), speed);
          }
        };

        setCurrent(0);
        root
          .querySelector('[data-slideshow-next]')
          ?.addEventListener('click', () => go(current + 1));
        root
          .querySelector('[data-slideshow-prev]')
          ?.addEventListener('click', () => go(current - 1));
        dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) setCurrent(slides.indexOf(entry.target));
            });
          },
          { root: track, threshold: 0.6 },
        );
        slides.forEach((slide) => io.observe(slide));

        const toggle = root.querySelector('[data-slideshow-toggle]');
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', (event) => {
          if (!root.contains(event.relatedTarget)) start();
        });
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', (event) => {
          if (!root.contains(event.relatedTarget)) start();
        });
        toggle?.addEventListener('click', () => {
          paused = !paused;
          toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          toggle.setAttribute(
            'aria-label',
            paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause,
          );
          if (paused) stop();
          else start();
        });
        start();

        root._citeraSlideshowGo = go;
        root._citeraSlideshowStop = stop;
        root._citeraSlideshowStart = start;
        root._citeraSlideshowDestroy = () => {
          stop();
          io.disconnect();
        };
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      rootsIn(event.target).forEach((root) => root._citeraSlideshowDestroy?.());
    });
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest?.('[data-slideshow-slide]');
      const root = slide?.closest('[data-slideshow]');
      if (!slide || !root || !root._citeraSlideshowGo) return;
      root._citeraSlideshowStop?.();
      const slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
      root._citeraSlideshowGo(slides.indexOf(slide), false);
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const root = event.target.closest?.('[data-slideshow]');
      root?._citeraSlideshowStart?.();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
